import {
  all, call, put, takeLatest,
} from '@redux-saga/core/effects';
import qs from 'qs';
import {
  changeGameLoadingState,
  saveFreeGameProviders,
  saveFreeGames,
  saveFreeGameAmountRestrictions,
  changeFreeGameLoadingState,
  changeFreeGameAmountLoadingState,
  saveFreeGamesV2Providers,
  saveFreeGamesV2,
  saveFreeGamesV2AmountRestrictions,
} from 'actions/game/gameActionCreator';
import { setErrorMessage } from 'app/settings/slices';
import { NetworkService } from 'services';
import GameActionType from 'actions/game/gameActionType';
import { AppConstants } from 'constants/index';
import { isJSON } from 'utils/utils';
import { getError } from 'utils/helpers';

function* getFreeGameProviders({ payload }) {
  try {
    const { brandId, params } = payload;
    const option = {
      params,
    };
    const { BonusAdmin, FreeSpin, Providers } = AppConstants.api;
    yield put(changeGameLoadingState(true));
    const { data: response } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, brandId, Providers], option);
    yield put(saveFreeGameProviders(response.providers));
    yield put(changeGameLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeGameLoadingState(false));
  }
}

function* getFreeGamesV2Providers({ payload }) {
  try {
    const { brandId, params } = payload;
    const option = {
      params,
    };
    const {
      BonusAdmin, FreeSpin, V2, Providers,
    } = AppConstants.api;
    yield put(changeGameLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, V2, brandId, Providers], option);
    yield put(saveFreeGamesV2Providers(data));
    yield put(changeGameLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeGameLoadingState(false));
  }
}

function* getFreeGames({ payload }) {
  try {
    const { brandId, params } = payload;
    const options = {
      params,
    };
    const { BonusAdmin, FreeSpin, Games } = AppConstants.api;
    yield put(changeFreeGameLoadingState(true));
    const { data: response } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, brandId, Games], options);
    yield put(saveFreeGames(response.games));
    yield put(changeFreeGameLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeFreeGameLoadingState(false));
  }
}

function* getFreeGamesV2({ payload }) {
  try {
    const { brandId, params } = payload;
    const options = {
      params,
    };
    const {
      BonusAdmin, FreeSpin, V2, Games,
    } = AppConstants.api;
    yield put(changeFreeGameLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, V2, brandId, Games], options);
    yield put(saveFreeGamesV2(data));
    yield put(changeFreeGameLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeFreeGameLoadingState(false));
  }
}

function* getFreeGameAmountRestrictions({ payload }) {
  try {
    const { brandId, params } = payload;
    const options = {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    };
    const {
      BonusAdmin, FreeSpin, Provider, Amount, Restrictions,
    } = AppConstants.api;
    yield put(changeFreeGameAmountLoadingState(true));
    const { data: response } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, brandId, Provider, Amount, Restrictions], options);
    yield put(saveFreeGameAmountRestrictions(response));
    yield put(changeFreeGameAmountLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeFreeGameAmountLoadingState(false));
  }
}

function* getFreeGamesV2AmountRestrictions({ payload }) {
  try {
    const { brandId, params } = payload;
    const options = {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    };
    const {
      BonusAdmin, FreeSpin, V2, GameAmount,
    } = AppConstants.api;
    yield put(changeFreeGameAmountLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BonusAdmin, FreeSpin, V2, brandId, GameAmount], options);
    yield put(saveFreeGamesV2AmountRestrictions(data));
    yield put(changeFreeGameAmountLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeFreeGameAmountLoadingState(false));
  }
}

export default function* gameSaga() {
  yield all([
    takeLatest(GameActionType.GET_FREE_GAME_PROVIDERS, getFreeGameProviders),
    takeLatest(GameActionType.GET_FREE_GAMES_V2_PROVIDERS, getFreeGamesV2Providers),
    takeLatest(GameActionType.GET_FREE_GAMES, getFreeGames),
    takeLatest(GameActionType.GET_FREE_GAME_AMOUNT_RESTRICTIONS, getFreeGameAmountRestrictions),
    takeLatest(GameActionType.GET_FREE_GAMES_V2, getFreeGamesV2),
    takeLatest(GameActionType.GET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS, getFreeGamesV2AmountRestrictions),
  ]);
}
